import type { SignInHost } from '../../../../lib/account-signin/sign-in-host';

export type AccountLoginOptions = SignInHost;
export function getAccountLoginOptions(document: Document = window.document): AccountLoginOptions {
    const source = document.querySelector<HTMLScriptElement>('#account-login-options');
    if (!source?.textContent) throw new Error('App Studio sign-in options are missing.');
    return JSON.parse(source.textContent) as AccountLoginOptions;
}
export function initializeAccountLogin(options: AccountLoginOptions): void {
    if (options.kind !== 'appstudio') throw new Error('Invalid sign-in host.');
    const element = document.querySelector('softools-account-signin');
    if (!element) throw new Error('Shared sign-in element is missing.');
    element.setAttribute('role', 'region');
    element.setAttribute('aria-label', 'App Studio sign-in');
}
if (document.querySelector('#account-login-options')) initializeAccountLogin(getAccountLoginOptions());
